export default __webpack_public_path__ + "static/media/vellumcourt.60d6526e.jpg";